'use client';

import React from 'react';
import Link from 'next/link';
import GlowingButton from '../shared/GlowingButton';
import DimensionLink from './DimensionLink';
// import { useAnimateOnScroll } from '@/lib/hooks/useIntersectionObserver';

const AboutPreview = () => {
  // Comment animasi untuk elemen about preview
  // const titleAnimation = useAnimateOnScroll('animate-fade', 'delay-300');
  // const contentAnimation = useAnimateOnScroll('animate-slide-up', 'delay-500');
  // const buttonAnimation = useAnimateOnScroll('animate-fade', 'delay-700');

  // Comment animasi untuk garis dekoratif
  // const topLineAnimation = useAnimateOnScroll('animate-fade', 'delay-400');
  // const bottomLineAnimation = useAnimateOnScroll('animate-fade', 'delay-600');
  // const leftLineAnimation = useAnimateOnScroll('animate-fade', 'delay-800');
  // const rightLineAnimation = useAnimateOnScroll('animate-fade', 'delay-1000');

  // Comment animasi untuk blur spots
  // const topRightBlurAnimation = useAnimateOnScroll('animate-fade', 'delay-300');
  // const bottomLeftBlurAnimation = useAnimateOnScroll(
  //   'animate-fade',
  //   'delay-500'
  // );

  return (
    <section className="w-full py-16 relative overflow-hidden about-preview-section">
      {/* Comment Clean minimal background */}
      {/* <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1015]/30 via-transparent to-[#081a17]/20" />

        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(0deg, rgba(16,185,129,0.05) 1px, transparent 1px)',
            backgroundSize: '100% 28px',
            opacity: 0.03,
          }}
        />

        <div
          ref={topLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute top-[15%] left-0 right-0 h-px ${topLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={bottomLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute bottom-[15%] left-0 right-0 h-px ${bottomLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={leftLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute top-[15%] bottom-[15%] left-[10%] w-px hidden md:block ${leftLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(180deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={rightLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute top-[15%] bottom-[15%] right-[10%] w-px hidden md:block ${rightLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(180deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={topRightBlurAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute -top-20 -right-20 w-96 h-96 rounded-full bg-emerald-500/10 blur-3xl ${topRightBlurAnimation.animationClasses}`}
          style={{ opacity: 0.15 }}
        ></div>

        <div
          ref={bottomLeftBlurAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute -bottom-20 -left-20 w-96 h-96 rounded-full bg-emerald-500/10 blur-3xl ${bottomLeftBlurAnimation.animationClasses}`}
          style={{ opacity: 0.15 }}
        ></div>
      </div> */}

      {/* Content Container */}
      <div className="relative z-10">
        {/* Section Header - Clean & Minimal */}
        <div className="mb-1 max-w-4xl mx-auto">
          <h1
            // ref={titleAnimation.ref as React.RefObject<HTMLHeadingElement>}
            // className={`justify-center text-4xl md:text-5xl mb-10 font-bold flex gap-3 ${titleAnimation.animationClasses}`}
            className="mb-10 text-center"
          >
            Website <span className="gradient-text">Overview</span>
          </h1>
        </div>

        <div
          // ref={contentAnimation.ref as React.RefObject<HTMLDivElement>}
          // className={`max-w-5xl space-y-8 ${contentAnimation.animationClasses}`}
          className="max-w-5xl mx-auto space-y-8 opacity-100"
        >
          <p>
            This is some brief what this site is all about. I built this website
            as my personal living journal and my online portfolio. I'm
            passionate at the intersection of law and technology. I built this
            website as a space to share my research, knowledge, and thoughts on
            law and technology related topics. Main focus of the articles on
            this website, particularly in the legal domain, is on{' '}
            <span className="text-neutral-100 font-semibold">
              general corporate and commercial law, mergers and acquisitions
              (M&A), and capital markets.{' '}
            </span>
            and also, you will find articles about other areas of law i.e
            bankruptcy & insolvency, dispute resolution, labour and etc.
            <br />
            <br />
            On the tech side, you'll find articles and thoughts on the legal
            framework surrounding{' '}
            <span className="text-neutral-100 font-semibold">
              fintech, cryptocurrency and blockchain
            </span>
            . With the Indonesian Financial Services Authority (OJK) actively
            working to make the local crypto investor safer, and there's always
            something new to explore and discuss. Beyond that, on this site
            you'll also find articles and thoughts on smart contracts, NFTs,
            airdrops, liquidity, and the broader decentralized peer-to-peer
            ecosystem. so you can enjoy digging into how these technologies
            work, not just from a technical standpoint, but also how the law is
            evolving to keep up with them.
            <br />
            <br />
            you can also find glossary related to law and technology in this
            site, and also you can find resources that might be useful to
            others, such as agreements, petitions, and other legal document
            templates. that might be useful to you.
            <br />
            <br />
            All of the articles and glossary are written in{' '}
            <span className="text-neutral-100 font-semibold">
              {' '}
              Bahasa Indonesia
            </span>
            , but if you prefer english, google translate should do the trick.😁
            I always try to ground my legal content with solid academic
            references, books, journals, and other reliable sources. Even im not
            a profesional (as for now) Hopefully, what I share here can spark
            your curiosity too or even help you navigate some of these complex
            topics a little easier. Feel free to explore and see what grabs your
            attention!
          </p>

          <p>
            That's a brief look at what this site is all about. If you'd like,
            you can learn a bit more about me.👇
          </p>
          <div
            // ref={buttonAnimation.ref as React.RefObject<HTMLDivElement>}
            // className={`pt-2 justify-center flex ${buttonAnimation.animationClasses}`}
            className="pt-2 justify-center flex opacity-100"
          >
            <GlowingButton href="/about/" variant="small" iconPosition="link">
              Learn More About Me
            </GlowingButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
